import e from "../../utils/classNames.js";
import { useEffect as t, useRef as n, useState as r } from "react";
import { noop as i } from "es-toolkit/function";
import { jsx as a } from "react/jsx-runtime";
//#region src/components/resizer/Resizer.tsx
var o = "x", s = "y", c = "left", l = "right", u = "top", d = "bottom", f = (e, t, n) => {
	if (!e) return;
	let r = e.ownerDocument;
	return r.addEventListener("mouseup", t), r.addEventListener("mousemove", n), r.addEventListener("touchend", t), r.addEventListener("touchmove", n), { remove: () => {
		r.removeEventListener("mouseup", t), r.removeEventListener("mousemove", n), r.removeEventListener("touchend", t), r.removeEventListener("touchmove", n);
	} };
}, p = (s) => {
	let { className: c = "", direction: u = o, position: d = l, onResizeStart: m = i, onResize: h = i, onResizeEnd: g = i, children: _, ...v } = s, y = n(null), [b, x] = r(!1), S = n(null), C = n(!1), w = n({
		x: 0,
		y: 0
	}), T = n(null), E = n(null);
	t(() => () => {
		I(), L();
	}, []);
	let D = (e) => {
		if (window.TouchEvent && e instanceof window.TouchEvent) return e.touches[0].clientX;
		if (e instanceof MouseEvent) return e.clientX;
		throw Error("Unsupported event type");
	}, O = (e) => {
		if (window.TouchEvent && e instanceof window.TouchEvent) return e.touches[0].clientY;
		if (e instanceof MouseEvent) return e.clientY;
		throw Error("Unsupported event type");
	}, k = (e) => {
		I(), C.current = !0, x(!0);
		let { clientX: t, clientY: n } = e.nativeEvent;
		w.current = {
			x: t,
			y: n
		}, m(e), y.current = f(S.current, N, j);
	}, A = (e) => {
		I(), C.current = !0, x(!0);
		let t = e.nativeEvent.touches[0];
		w.current = {
			x: t.clientX,
			y: t.clientY
		}, m(e), y.current = f(S.current, N, j);
	}, j = (e) => {
		C.current && (T.current = {
			x: D(e),
			y: O(e)
		}, E.current === null && (E.current = P().requestAnimationFrame(M)));
	}, M = () => {
		E.current = null;
		let e = T.current;
		if (T.current = null, !e) return;
		let t = 0;
		u === p.HORIZONTAL && (t = w.current.x - e.x), u === p.VERTICAL && (t = w.current.y - e.y), t !== 0 && h(t), w.current = e;
	}, N = (e) => {
		F(), C.current = !1, x(!1), g(e), L();
	}, P = () => S.current?.ownerDocument.defaultView ?? window, F = () => {
		E.current !== null && P().cancelAnimationFrame(E.current), M();
	}, I = () => {
		E.current !== null && P().cancelAnimationFrame(E.current), E.current = null, T.current = null;
	}, L = () => {
		y.current && y.current.remove();
	}, R = e("Resizer", u === "x" && "resize-horizontal", u === "y" && "resize-vertical", d === "left" && "resize-left", d === "right" && "resize-right", d === "top" && "resize-top", d === "bottom" && "resize-bottom", b && "is-dragging", c && c);
	return /* @__PURE__ */ a("div", {
		ref: S,
		className: R,
		onMouseDown: k,
		onTouchStart: A,
		...v,
		children: _
	});
};
p.HORIZONTAL = o, p.VERTICAL = s, p.LEFT = c, p.RIGHT = l, p.TOP = u, p.BOTTOM = d;
//#endregion
export { p as default };

//# sourceMappingURL=Resizer.js.map